import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { DASHBOARD } from "../RouteConstant";

export default function PublicRoute() {
  const { isAuthenticated } = useSelector((state) => state.auth);

  if (isAuthenticated) {
    return <Navigate to={DASHBOARD} replace />;
  }

  return <Outlet />;
}